import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TagSelector } from "../../../components/Taxonomy/TagSelector";
import { Stack } from "../../../styles/Containers";
import { StyledButton } from "../../../styles/matieralui/Button";
import { StyledA, StyledH6, StyledP } from "../../../styles/StyledHTML";
import { IconPerson } from "../../Icons";
import { createLibrary, searchLibrary } from "../Library/redux/library.actions";
import { FullLibraries } from "../Library/redux/library.selectors";
import { createLocation, searchLocations } from "../Location/redux/locations.actions";
import { FullLocations } from "../Location/redux/locations.selectors";
import { createPerson, searchPeople } from "../People/redux/people.actions";
import { FullPeople } from "../People/redux/people.selectors";
import { Screen } from "../Photostream/Uploader";
export const OnboardingPeople = ({ type = null, onComplete }) => {
    const dispatch = useDispatch();
    const store = FullPeople();
    const [items, setItems] = useState([]);


    useEffect(() => { if (store.createSuccess) onComplete(); }, [store.createLoading])
    useEffect(() => { dispatch(searchPeople(0, null, null, 'all', {})) }, [])
    useEffect(() => { if (store?.items?.count > 0) onComplete(); }, [store])

    const createItem = () => dispatch(createPerson({ name: items[0]?.name }));

    let heading = "Add one person";
    let description = "These are the people that appear in your photos. Let's just add one for now. You can add more later.";
    let examples = "Examples: Full Name, John Doe";
    let label = "Enter a Person's Name";

    // Church Content
    if (type == 'church') {
        heading = "Add one person.";
        description = "These are the people that appear in your photos. Let's just add one for now. You can add more later.";
        examples = "Examples: Pastor John, Jane Doe, Joyce, Pastor Kim";
        label = "Enter a Person's Name"
    }

    return (
        <Screen>
            <Stack textAlign="center" maxWidth="600px">
                <StyledP><IconPerson /></StyledP>
                <StyledH6>{heading}</StyledH6>
                <StyledP>{description}</StyledP>
                <br />
                <StyledP light>{examples}</StyledP>


                <TagSelector
                    noLabels={true}
                    inputLabel={label}
                    existingOptions={items}
                    options={store?.items?.rows}
                    onChange={(v) => setItems(v)}
                    limit={1}
                />


                <Stack width="100%" align="center" justify="center" thinking={store.createLoading}>
                    <StyledButton disabled={(items?.length < 1) ? true : false} variant="contained" color="blue" onClick={createItem}>Create</StyledButton>
                    <StyledP light small><StyledA onClick={onComplete}>skip</StyledA></StyledP>
                </Stack>

            </Stack>

        </Screen>
    )
}